const Snap = require('snapsvg');
const Matrix = require('../../../../viscomjs/utils/Matrix');

// Inverse rotation and shift only

const _createRender = behavior => {
    const snap = Snap(behavior.el.querySelector('svg'));
    const root = snap.select(behavior.selector);
    const clone = root.clone();
    if (!root) return () => {};

    const chn = clone.children();
    if (!chn || chn.length < 1) return () => {};

    root.parent().prepend(clone);
    root.node.style.display = 'none';

    const m0 = root.transform().localMatrix;
    m0.translate(behavior.deltaX, behavior.deltaY);

    chn.forEach(g => {
        const cloneChnG = snap.g();
        const chn2 = g.children();

        g.append(cloneChnG);

        chn2.forEach(ch => {
            cloneChnG.append(ch);
        });

        cloneChnG.transform(m0);
        cloneChnG.node.classList.add('cloneChnG');
    });

    // prettier-ignore
    return () => {
        const m1 = root.transform().localMatrix;
        const mx1 = new Matrix([
            m1.a, m1.c, m1.e, 0,
            m1.b, m1.d, m1.f, 0,
            0, 0, 1, 0,
            0, 0, 0, 1
        ]);
        const mx2 = mx1.inverse().m;

        const m2 = `matrix(${mx2[0]}, ${mx2[4]}, ${mx2[1]}, ${mx2[5]}, ${mx2[2]}, ${mx2[6]})`;

        clone.transform(m1);
        chn.forEach(g => {
            g.transform(m2);
        });
    };
};

module.exports = (el, selector, deltaX = 0, deltaY = 0) => {
    const behavior = {
        el: el,
        selector: selector,
        deltaX: deltaX,
        deltaY: deltaY,
        chn: [],
        _hasRender: false
    };

    behavior.render = () => {
        const chn = el.childNodes;
        if (chn.length < 1) return;

        behavior.render = _createRender(behavior);
    };

    return behavior;
};
